import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "../lib/data";
import { Logo } from "./Navbar";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ws-dark text-ws-bg px-5 sm:px-8 lg:px-14 pt-20 pb-28 sm:pb-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12 pb-12 sm:pb-16 border-b border-ws-bg/15">
          <div className="md:col-span-2 lg:col-span-5">
            <Logo dark testid="footer-logo-home" />
            <p className="font-display text-3xl sm:text-4xl mt-8 leading-tight max-w-md">From idea to shelf.</p>
            <p className="text-ws-bg/60 mt-6 max-w-sm text-sm leading-relaxed">
              The manufacturing bridge between an idea and a finished product — for beverage mixes,
              hydration products, energy stick packs and functional beverages.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="label text-ws-accent mb-5">Explore</p>
            <ul className="space-y-1">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} data-testid={`footer-nav-${n.to.slice(1)}`} className="min-h-11 inline-flex items-center text-ws-bg/75 hover:text-ws-bg transition-colors text-sm">{n.label}</Link>
                </li>
              ))}
              <li><Link to="/request-a-quote" data-testid="footer-request-quote" className="min-h-11 inline-flex items-center text-ws-bg/75 hover:text-ws-bg transition-colors text-sm">Request a Quote</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="label text-ws-accent mb-5">Contact</p>
            <ul className="space-y-1 text-sm text-ws-bg/75">
              <li><a href="mailto:wisperwickstudio@gmail.com" data-testid="footer-email" className="min-h-11 inline-flex items-center break-all hover:text-ws-bg transition-colors">wisperwickstudio@gmail.com</a></li>
              <li><a href="tel:+919910912419" data-testid="footer-phone" className="min-h-11 inline-flex items-center hover:text-ws-bg transition-colors">+91 99109 12419</a></li>
              <li data-testid="footer-business-hours">Mon–Saturday, 9AM–7PM</li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/wisperwickstudio/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="min-h-11 text-ws-bg/60 hover:text-ws-accent text-xs inline-flex items-center gap-1 transition-colors">
                Instagram<ArrowUpRight className="w-3 h-3" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-ws-bg/50">
          <p>© {new Date().getFullYear()} Wisperwick Studio. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-1">
            <a href="#" data-testid="footer-privacy" className="min-h-11 inline-flex items-center hover:text-ws-bg transition-colors">Privacy Policy</a>
            <a href="#" data-testid="footer-terms" className="min-h-11 inline-flex items-center hover:text-ws-bg transition-colors">Terms</a>
            <Link to="/request-a-quote" data-testid="footer-contact" className="min-h-11 inline-flex items-center hover:text-ws-bg transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
